import React from "react";
import AboutUs from "../components/AboutUs";
import MarketPlaceLayout from "../components/Layout/MarketPlaceLayout";


function AboutUsPage() {
  return (
    <MarketPlaceLayout>
          <AboutUs />
    </MarketPlaceLayout>
  );
}

export default AboutUsPage;
